import {
	type TProductDataRegions,
	type TSearchConfigAPIResponse,
} from '@atlassian/search-client/fetch-search-config';

/**
 * Gets the product data regions for the given cloudId from site metadata.
 */
export const getProductDataRegions = (
	firstPartyResponse?: TSearchConfigAPIResponse,
	cloudId?: string,
): TProductDataRegions | undefined => {
	if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) {
		return undefined;
	}

	return firstPartyResponse.siteMetadata.find(
		(metadata) => metadata.siteId === cloudId && !!metadata.productDataRegions,
	)?.productDataRegions;
};
